import { render, staticRenderFns } from "./NewRirekishoSinglePreview.vue?vue&type=template&id=10ef64a0"
import script from "./NewRirekishoSinglePreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewRirekishoSinglePreview.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports